import ContentPage from './ContentPage';

export default function PrivacyPage() {
  return (
    <ContentPage
      eyebrow="Legal"
      title="Privacy Policy & Cookies"
      lead="How Nayavarnam collects, uses, and looks after your information when you shop with us."
    >
      <section>
        <h3>What we collect</h3>
        <p>
          When you create an account or place an enquiry, we may collect your name, email, phone
          number, and order details. Technical data such as device and basic usage may be processed
          to keep the site secure and reliable.
        </p>
      </section>
      <section>
        <h3>How we use it</h3>
        <ul>
          <li>To create and manage your account, cart, and wishlist.</li>
          <li>To fulfil orders and respond to your messages.</li>
          <li>To send transactional mail such as order updates.</li>
          <li>To improve the store experience and prevent misuse.</li>
        </ul>
      </section>
      <section>
        <h3>Cookies</h3>
        <p>
          We use essential storage (for example session tokens and intro preferences) so the site
          can remember that you are signed in and work smoothly. These are required for core
          features and are not used to sell your data.
        </p>
      </section>
      <section>
        <h3>Your choices</h3>
        <p>
          You may request access or correction of your account details by contacting us. You can
          sign out at any time from your account page. If you have privacy questions, reach us via
          the Contact section on the home page.
        </p>
      </section>
    </ContentPage>
  );
}
